import { Link } from 'react-router-dom';
import classNames from 'classnames';
import './Breadcrumbs.scss';

export interface Bread {
  title?: string;
  url?: string;
}

interface BreadcrumbsProps {
  breads?: Bread[];
  className?: string;
}

export const Breadcrumbs = ({ breads, className }: BreadcrumbsProps) => {
  return (
    <div className={classNames('Breadcrumbs', className)}>
      {breads?.map(
        (bread, idx) =>
          bread.title &&
          bread.url && (
            <Link to={bread.url} key={idx}>
              {bread.title}
            </Link>
          )
      )}
    </div>
  );
};
